function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationCarFrontRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 17a1.5 1.5 0 10.001 3.001A1.5 1.5 0 007.5 17zM24.5 17a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0024.5 17z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 23h-8v-4h-8v4H4v-7.395L5.07 14h21.86L28 15.605V23zm-14 0h4v-2h-4v2zM7.669 5h16.662l1.273 7H6.396l1.273-7zm21.995 9.496l-1.07-1.605a1.986 1.986 0 00-.929-.735l-1.366-7.514A2 2 0 0024.331 3H7.669a2 2 0 00-1.968 1.642l-1.366 7.514c-.371.148-.7.392-.929.735l-1.07 1.605A2.002 2.002 0 002 15.605V23a2 2 0 002 2v2a2 2 0 002 2h1a2 2 0 002-2v-2h14v2a2 2 0 002 2h1a2 2 0 002-2v-2a2 2 0 002-2v-7.395c0-.394-.117-.78-.336-1.109z",
    fill: props.color
  }));
}

export default SvgIconTransportationCarFrontRexOutline;